import { Box, Typography } from "@material-ui/core";
import React from "react";

interface EditButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  title: string;
  icon: React.ReactNode;
  iconColor?: string;
}

export const EditButton = (props: EditButtonProps) => {
  const { title, icon, iconColor, ...rest } = props;
  return (
    <Box
      style={{
        color: "var(--color-primary)",
        gap: "10px",
        ...(iconColor && { color: iconColor }),
      }}
      display="flex"
      alignItems="center"
      {...rest}
    >
      {icon}
      <Typography variant="h3">{title}</Typography>
    </Box>
  );
};
